import SequenceService from "@/src/api/SequenceService.js";
import { toGetAllEntityLists } from "@/src/utils/utils.js";

const MutationTypes = {
  SET_SEQUENCES: "SET_SEQUENCES",
  SET_SEQUENCES_FETCHED: "SET_SEQUENCES_FETCHED",
  SET_ENTITY_LISTS: "SET_ENTITY_LISTS",
  SET_ENTITY_LISTS_FETCHED: "SET_ENTITY_LISTS_FETCHED",
};

const state = {
  sequences: [],
  sequencesFetched: false,
  entityLists: {},
  entityListsFetched: {},
};

const mutations = {
  [MutationTypes.SET_SEQUENCES](state, sequences) {
    state.sequences = sequences;
    state.sequencesFetched = true;
  },
  [MutationTypes.SET_SEQUENCES_FETCHED](state, fetched) {
    state.sequencesFetched = fetched;
  },
  [MutationTypes.SET_ENTITY_LISTS](state, { entityType, lists }) {
    state.entityLists = { ...state.entityLists, [entityType]: lists };
    state.entityListsFetched = {
      ...state.entityListsFetched,
      [entityType]: true,
    };
  },
  [MutationTypes.SET_ENTITY_LISTS_FETCHED](state, { entityType, fetched }) {
    state.entityListsFetched = {
      ...state.entityListsFetched,
      [entityType]: fetched,
    };
  },
};

const actions = {
  async fetchSequences({ commit, state }, { force } = {}) {
    if (state.sequencesFetched && !force) return;
    try {
      const response = await SequenceService.fetchSequences(0, 20, "");
      if (response?.success) {
        commit(MutationTypes.SET_SEQUENCES, response?.sequences || []);
      }
    } catch (error) {
      console.error("Error fetching sequences for store:", error);
    }
  },

  async fetchEntityLists({ commit, state }, { entityType, force } = {}) {
    if (!entityType) return;
    if (state.entityListsFetched[entityType] && !force) return;
    try {
      const lists = await toGetAllEntityLists(entityType);
      commit(MutationTypes.SET_ENTITY_LISTS, { entityType, lists });
    } catch (error) {
      console.error("Error fetching entity lists for store:", error);
    }
  },

  invalidateSequences({ commit }) {
    commit(MutationTypes.SET_SEQUENCES_FETCHED, false);
  },

  invalidateEntityLists({ commit }, { entityType } = {}) {
    if (entityType) {
      commit(MutationTypes.SET_ENTITY_LISTS_FETCHED, {
        entityType,
        fetched: false,
      });
    }
  },
};

const getters = {
  sequences: (state) => state.sequences,
  entityLists: (state) => (entityType) =>
    state.entityLists[entityType] || [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
